import { render, staticRenderFns } from "./UpdateSMSLimit.vue?vue&type=template&id=691f9020&"
import script from "./UpdateSMSLimit.vue?vue&type=script&lang=js&"
export * from "./UpdateSMSLimit.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSMSLimit.vue?vue&type=style&index=0&id=691f9020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports